import { render } from "./SelectedDetPop.vue?vue&type=template&id=23110544"
import script from "./SelectedDetPop.vue?vue&type=script&lang=js"
export * from "./SelectedDetPop.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/share/application/sanar-provider-webapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__